import React from 'react';
import { Compass, ExternalLink } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { DistanceFilter } from './DistanceFilter';

export default function ActivitesTab({ filteredActivites, activiteFilter, setActiviteFilter }) {
  return (
    <div data-testid="activites-tab">
      <div className="mb-6">
        <h2 className="font-['Playfair_Display'] text-2xl font-bold text-zinc-900 mb-2">Que faire autour ?</h2>
        <p className="text-zinc-600 mb-4">Découvrez la région et ses trésors : patrimoine, nature, loisirs</p>
        <DistanceFilter value={activiteFilter} onChange={setActiviteFilter} testId="activite-filter" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredActivites.map((a, index) => {
          const IconComponent = a.icon || Compass;
          return (
            <Card key={index} className="border-0 shadow-lg hover:-translate-y-1 transition-all" data-testid={`activite-${index}`}>
              <CardContent className="p-6">
                <div className="flex justify-between items-start mb-3">
                  <div className="flex items-center gap-2">
                    <div className={`p-2 rounded-lg ${a.category === 'culture' ? 'bg-fuchsia-100' : a.category === 'nature' ? 'bg-lime-100' : 'bg-blue-100'}`}>
                      <IconComponent className={`h-4 w-4 ${a.category === 'culture' ? 'text-fuchsia-600' : a.category === 'nature' ? 'text-lime-600' : 'text-blue-600'}`} />
                    </div>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${a.category === 'culture' ? 'bg-fuchsia-100 text-fuchsia-600' : a.category === 'nature' ? 'bg-lime-100 text-lime-600' : 'bg-blue-100 text-blue-600'}`}>
                      {a.type}
                    </span>
                  </div>
                  <Badge variant="outline" className="text-xs">{a.distanceLabel}</Badge>
                </div>
                <h3 className="font-bold text-zinc-900 mb-2">{a.name}</h3>
                <p className="text-sm text-zinc-600 mb-3">{a.description}</p>
                {a.url && (
                  <a href={a.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs text-fuchsia-600 hover:text-fuchsia-700">
                    <ExternalLink className="h-3 w-3" /> Voir le site
                  </a>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>
      {filteredActivites.length === 0 && (
        <div className="text-center py-8 text-zinc-500">Aucune activité trouvée pour ce rayon. Essayez un filtre plus large.</div>
      )}
      <div className="mt-8 text-center">
        <a href="https://www.tourisme-vienne.com" target="_blank" rel="noopener noreferrer">
          <Button className="bg-lime-600 hover:bg-lime-700 text-white rounded-full">Découvrir l'Office de Tourisme</Button>
        </a>
      </div>
    </div>
  );
}
